import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

import { useTrans } from "../../../hooks";

function ExpandPromptButton({ expandPrompt, isPaid }) {
  const { trans } = useTrans();

  var { weblink = "", prompt = "", isLink = false } = expandPrompt || {};
  if (isPaid) {
    weblink = "/catalog/wattpadoriginals";
    prompt = trans("See all");
  }

  if (!weblink || !prompt) {
    return null;
  }

  return (
    <a
      href={weblink}
      className={classnames("expand-prompt-button on-navigate", {
        "btn-secondary": !isLink
      })}
    >
      {prompt}
    </a>
  );
}

ExpandPromptButton.propTypes = {
  expandPrompt: PropTypes.object,
  isPaid: PropTypes.bool,
  isLink: PropTypes.bool
};

export { ExpandPromptButton };
